import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Users, Sparkles, CalendarClock, MoreHorizontal } from "lucide-react";

const ITEMS = [
  { to: "/m",           end: true, label: "Oggi",     icon: Home,            testid: "mnav-today" },
  { to: "/m/clienti",               label: "Clienti",  icon: Users,           testid: "mnav-clients" },
  { to: "/m/comandante",            label: "AI",       icon: Sparkles,        testid: "mnav-commander" },
  { to: "/m/agenda",                label: "Agenda",   icon: CalendarClock,   testid: "mnav-agenda" },
  { to: "/m/piu",                   label: "Più",      icon: MoreHorizontal,  testid: "mnav-more" },
];

export default function MobileBottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 safe-bottom"
      style={{
        background: "rgba(10,25,47,0.97)",
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        borderTop: "1px solid rgba(255,255,255,0.07)",
      }}
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-5" style={{ height: 60 }}>
        {ITEMS.map((it) => {
          const Icon = it.icon;
          return (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testid}
              className="flex flex-col items-center justify-center gap-1 relative transition-opacity active:opacity-60"
              style={({ isActive }) => ({
                color: isActive ? "#B7955B" : "rgba(148,163,184,0.7)",
              })}
            >
              {({ isActive }) => (
                <>
                  {/* Active indicator dot */}
                  {isActive && (
                    <div
                      className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full"
                      style={{ background: "#B7955B" }}
                    />
                  )}
                  <Icon
                    className="w-[22px] h-[22px]"
                    strokeWidth={isActive ? 2 : 1.6}
                  />
                  <span
                    className="leading-none"
                    style={{
                      fontSize: 10,
                      fontWeight: isActive ? 600 : 500,
                      letterSpacing: "0.01em",
                    }}
                  >
                    {it.label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
